// Mappers for admin-related entities
// Identity mappers for 1:1 mapping

import type {
  ApplyPartMasterDataChangesResponseDto,
  ApplyNcFileVersionMasterDataChangesResponseDto,
} from '../../generated/models';

import type { ApplyPartMasterDataChangesResponse, ApplyNcFileVersionMasterDataChangesResponse } from '@api/domain/types';

// Response mappers (identity for 1:1)
export const toApplyPartMasterDataChangesResponse = (
  dto: ApplyPartMasterDataChangesResponseDto
): ApplyPartMasterDataChangesResponse => dto;
export const toApplyNcFileVersionMasterDataChangesResponse = (
  dto: ApplyNcFileVersionMasterDataChangesResponseDto
): ApplyNcFileVersionMasterDataChangesResponse => dto;
